// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AnswerCardExerciseData, AnswerCardExerciseErrors, AnswerCardExerciseResponses, AppendTurnData, AppendTurnErrors, AppendTurnResponses, BackgroundData, BackgroundErrors, BackgroundResponses, CheckParentPinData, CheckParentPinErrors, CheckParentPinResponses, CheckPasswordLinkData, CheckPasswordLinkErrors, CheckPasswordLinkResponses, ChildCurriculumData, ChildCurriculumErrors, ChildCurriculumResponses, ChildMetricsData, ChildMetricsErrors, ChildMetricsResponses, ChildProgressData, ChildProgressErrors, ChildProgressResponses, ChildReportData, ChildReportErrors, ChildReportResponses, ChildSignInData, ChildSignInErrors, ChildSignInResponses, ChildSignOutData, ChildSignOutErrors, ChildSignOutResponses, ClaimReferralData, ClaimReferralErrors, ClaimReferralResponses, CreateChildData, CreateChildErrors, CreateChildResponses, CreateMemberData, CreateMemberErrors, CreateMemberResponses, CreateOrganizationData, CreateOrganizationErrors, CreateOrganizationResponses, CreateShareCardData, CreateShareCardErrors, CreateShareCardResponses, CreateSheetData, CreateSheetErrors, CreateSheetResponses, DeleteChildData, DeleteChildErrors, DeleteChildResponses, DeleteMemberData, DeleteMemberErrors, DeleteMemberResponses, DeleteSessionData, DeleteSessionErrors, DeleteSessionResponses, DeleteSheetData, DeleteSheetErrors, DeleteSheetResponses, FinishSessionData, FinishSessionErrors, FinishSessionResponses, ForgotPasswordData, ForgotPasswordErrors, ForgotPasswordResponses, GetCardRoundData, GetCardRoundErrors, GetCardRoundResponses, GetChildData, GetChildErrors, GetChildResponses, GetCurriculumData, GetCurriculumErrors, GetCurriculumResponses, GetMemberData, GetMemberErrors, GetMemberResponses, GetOrganizationData, GetOrganizationErrors, GetOrganizationResponses, GetPuzzleData, GetPuzzleErrors, GetPuzzleResponses, GetReferralData, GetReferralErrors, GetReferralResponses, GetSessionData, GetSessionErrors, GetSessionResponses, GetSheetData, GetSheetErrors, GetSheetResponses, GetSubscriptionData, GetSubscriptionErrors, GetSubscriptionResponses, GrantLernfachTimeData, GrantLernfachTimeErrors, GrantLernfachTimeResponses, LernfachData, LernfachErrors, LernfachResponses, ListChildrenData, ListChildrenErrors, ListChildrenResponses, ListChildSessionsData, ListChildSessionsErrors, ListChildSessionsResponses, ListLibraryData, ListLibraryErrors, ListLibraryResponses, ListMembersData, ListMembersErrors, ListMembersResponses, ListShareCardsData, ListShareCardsErrors, ListShareCardsResponses, ListSheetsData, ListSheetsErrors, ListSheetsResponses, LiveTokenData, LiveTokenErrors, LiveTokenResponses, LoginData, LoginErrors, LoginResponses, LogoutData, LogoutErrors, LogoutResponses, MarkTopicData, MarkTopicErrors, MarkTopicResponses, MeData, MeErrors, MeResponses, NextSheetData, NextSheetErrors, NextSheetResponses, OpenPortalData, OpenPortalErrors, OpenPortalResponses, PuzzleHintData, PuzzleHintErrors, PuzzleHintResponses, PuzzleShelfData, PuzzleShelfErrors, PuzzleShelfResponses, RefreshSessionData, RefreshSessionErrors, RefreshSessionResponses, RegisterData, RegisterErrors, RegisterResponses, ReplyData, ReplyErrors, ReplyResponses, ResendVerificationData, ResendVerificationErrors, ResendVerificationResponses, RevokeShareCardData, RevokeShareCardErrors, RevokeShareCardResponses, SavePuzzleData, SavePuzzleErrors, SavePuzzleResponses, SetChildPinData, SetChildPinErrors, SetChildPinResponses, SetLernfachSubjectData, SetLernfachSubjectErrors, SetLernfachSubjectResponses, SetParentPinData, SetParentPinErrors, SetParentPinResponses, SetPasswordData, SetPasswordErrors, SetPasswordResponses, StartCardRoundData, StartCardRoundErrors, StartCardRoundResponses, StartCheckoutData, StartCheckoutErrors, StartCheckoutResponses, StartPuzzleData, StartPuzzleErrors, StartPuzzleResponses, StartSessionData, StartSessionErrors, StartSessionResponses, StartSheetSessionData, StartSheetSessionErrors, StartSheetSessionResponses, StartTextSessionData, StartTextSessionErrors, StartTextSessionResponses, TranscribeData, TranscribeErrors, TranscribeResponses, UpdateChildData, UpdateChildErrors, UpdateChildResponses, UpdateMemberData, UpdateMemberErrors, UpdateMemberResponses, UpdateOrganizationData, UpdateOrganizationErrors, UpdateOrganizationResponses, VerifyEmailData, VerifyEmailErrors, VerifyEmailResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Mail the confirmation link again
 *
 * Answers the same whether or not the address has an unconfirmed account.
 */
export const resendVerification = <ThrowOnError extends boolean = false>(options: Options<ResendVerificationData, ThrowOnError>): RequestResult<ResendVerificationResponses, ResendVerificationErrors, ThrowOnError> => (options.client ?? client).post<ResendVerificationResponses, ResendVerificationErrors, ThrowOnError>({
    url: '/auth/email/resend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm an address with a mailed link's token
 */
export const verifyEmail = <ThrowOnError extends boolean = false>(options: Options<VerifyEmailData, ThrowOnError>): RequestResult<VerifyEmailResponses, VerifyEmailErrors, ThrowOnError> => (options.client ?? client).post<VerifyEmailResponses, VerifyEmailErrors, ThrowOnError>({
    url: '/auth/email/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign in with email and password
 *
 * Returns an access token for the Authorization header and a refresh token to renew it.
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>): RequestResult<LoginResponses, LoginErrors, ThrowOnError> => (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    url: '/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * End the session a refresh token belongs to
 */
export const logout = <ThrowOnError extends boolean = false>(options: Options<LogoutData, ThrowOnError>): RequestResult<LogoutResponses, LogoutErrors, ThrowOnError> => (options.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({
    url: '/auth/logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Whether a mailed link's token can still set a password
 *
 * Does not spend the token; lets the page say a link has expired before a password is typed.
 */
export const checkPasswordLink = <ThrowOnError extends boolean = false>(options: Options<CheckPasswordLinkData, ThrowOnError>): RequestResult<CheckPasswordLinkResponses, CheckPasswordLinkErrors, ThrowOnError> => (options.client ?? client).post<CheckPasswordLinkResponses, CheckPasswordLinkErrors, ThrowOnError>({
    url: '/auth/password/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mail a link to choose a new password
 *
 * Answers the same whether or not the address has an account.
 */
export const forgotPassword = <ThrowOnError extends boolean = false>(options: Options<ForgotPasswordData, ThrowOnError>): RequestResult<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError> => (options.client ?? client).post<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError>({
    url: '/auth/password/forgot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Choose a password with a mailed link's token
 *
 * Ends every session the account had.
 */
export const setPassword = <ThrowOnError extends boolean = false>(options: Options<SetPasswordData, ThrowOnError>): RequestResult<SetPasswordResponses, SetPasswordErrors, ThrowOnError> => (options.client ?? client).post<SetPasswordResponses, SetPasswordErrors, ThrowOnError>({
    url: '/auth/password/set',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trade a refresh token for fresh tokens
 *
 * The refresh token is single use: the response carries its replacement.
 */
export const refreshSession = <ThrowOnError extends boolean = false>(options: Options<RefreshSessionData, ThrowOnError>): RequestResult<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError> => (options.client ?? client).post<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError>({
    url: '/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a parent account
 *
 * Mails a link that confirms the address. Nothing can be signed into until it is followed.
 */
export const register = <ThrowOnError extends boolean = false>(options: Options<RegisterData, ThrowOnError>): RequestResult<RegisterResponses, RegisterErrors, ThrowOnError> => (options.client ?? client).post<RegisterResponses, RegisterErrors, ThrowOnError>({
    url: '/auth/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Open a checkout
 *
 * Bills one seat per child, at least one. Answers 503 where billing is not configured.
 */
export const startCheckout = <ThrowOnError extends boolean = false>(options: Options<StartCheckoutData, ThrowOnError>): RequestResult<StartCheckoutResponses, StartCheckoutErrors, ThrowOnError> => (options.client ?? client).post<StartCheckoutResponses, StartCheckoutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/billing/checkout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Manage the subscription
 *
 * The provider's own page: the card, the invoices, and cancelling. A family that has never been to checkout has nothing to manage and gets a 400.
 */
export const openPortal = <ThrowOnError extends boolean = false>(options: Options<OpenPortalData, ThrowOnError>): RequestResult<OpenPortalResponses, OpenPortalErrors, ThrowOnError> => (options.client ?? client).post<OpenPortalResponses, OpenPortalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/billing/portal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The family's plan
 *
 * A parent only. On a deployment with no payment provider `configured` is false: nothing is charged and nothing is gated.
 */
export const getSubscription = <ThrowOnError extends boolean = false>(options: Options<GetSubscriptionData, ThrowOnError>): RequestResult<GetSubscriptionResponses, GetSubscriptionErrors, ThrowOnError> => (options.client ?? client).get<GetSubscriptionResponses, GetSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/billing/subscription',
    ...options
});

/**
 * Sign in as a child, with a PIN
 *
 * Five wrong tries lock the PIN for a minute. The token is shown once and is good for six hours — a school afternoon, not a week, because the device is shared.
 */
export const childSignIn = <ThrowOnError extends boolean = false>(options: Options<ChildSignInData, ThrowOnError>): RequestResult<ChildSignInResponses, ChildSignInErrors, ThrowOnError> => (options.client ?? client).post<ChildSignInResponses, ChildSignInErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/child-sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The family's children
 */
export const listChildren = <ThrowOnError extends boolean = false>(options: Options<ListChildrenData, ThrowOnError>): RequestResult<ListChildrenResponses, ListChildrenErrors, ThrowOnError> => (options.client ?? client).get<ListChildrenResponses, ListChildrenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children',
    ...options
});

/**
 * Add a child profile
 *
 * A parent only. The PIN is set here because a child cannot exist without one — there would be no way to sign in as them.
 */
export const createChild = <ThrowOnError extends boolean = false>(options: Options<CreateChildData, ThrowOnError>): RequestResult<CreateChildResponses, CreateChildErrors, ThrowOnError> => (options.client ?? client).post<CreateChildResponses, CreateChildErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Where a child stands against the Lehrplan
 *
 * Every topic the parent has marked (practice: nacharbeiten, solid: sitzt) or a sheet was written on; a topic not listed is open. The mark is the parent's own reading. A parent only.
 */
export const childCurriculum = <ThrowOnError extends boolean = false>(options: Options<ChildCurriculumData, ThrowOnError>): RequestResult<ChildCurriculumResponses, ChildCurriculumErrors, ThrowOnError> => (options.client ?? client).get<ChildCurriculumResponses, ChildCurriculumErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{childId}/curriculum',
    ...options
});

/**
 * Mark a topic for a child
 *
 * open clears the mark. A parent only.
 */
export const markTopic = <ThrowOnError extends boolean = false>(options: Options<MarkTopicData, ThrowOnError>): RequestResult<MarkTopicResponses, MarkTopicErrors, ThrowOnError> => (options.client ?? client).put<MarkTopicResponses, MarkTopicErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{childId}/curriculum',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * A child's Lernfach
 *
 * The subjects with Lernkarten, the cards in play and today's clock. A child sees the subjects a parent opened and no Stufen; a parent sees every subject, each card's Stufe, what it keeps missing, and the last rounds.
 */
export const lernfach = <ThrowOnError extends boolean = false>(options: Options<LernfachData, ThrowOnError>): RequestResult<LernfachResponses, LernfachErrors, ThrowOnError> => (options.client ?? client).get<LernfachResponses, LernfachErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{childId}/lernfach',
    ...options
});

/**
 * Start a round
 *
 * The child's own. Up to three due cards, three new exercises each; an unfinished round is resumed instead. 409 `LERNFACH_DONE` when nothing is due today, `LERNFACH_TIME_UP` when a parent has to grant more time.
 */
export const startCardRound = <ThrowOnError extends boolean = false>(options: Options<StartCardRoundData, ThrowOnError>): RequestResult<StartCardRoundResponses, StartCardRoundErrors, ThrowOnError> => (options.client ?? client).post<StartCardRoundResponses, StartCardRoundErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{childId}/lernfach/rounds',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Open or close a Lernfach
 *
 * A parent only. Closing keeps the cards, so opening again picks up where it was.
 */
export const setLernfachSubject = <ThrowOnError extends boolean = false>(options: Options<SetLernfachSubjectData, ThrowOnError>): RequestResult<SetLernfachSubjectResponses, SetLernfachSubjectErrors, ThrowOnError> => (options.client ?? client).put<SetLernfachSubjectResponses, SetLernfachSubjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{childId}/lernfach/subjects/{subject}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Thirty minutes more
 *
 * From a parent's device, nothing more is needed. From the child's device, `parentPin` is the parent PIN a parent typed there; a wrong one is 403 `BAD_PARENT_PIN`, and five lock it for a minute.
 */
export const grantLernfachTime = <ThrowOnError extends boolean = false>(options: Options<GrantLernfachTimeData, ThrowOnError>): RequestResult<GrantLernfachTimeResponses, GrantLernfachTimeErrors, ThrowOnError> => (options.client ?? client).post<GrantLernfachTimeResponses, GrantLernfachTimeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{childId}/lernfach/time',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The parent's figures for a child
 */
export const childMetrics = <ThrowOnError extends boolean = false>(options: Options<ChildMetricsData, ThrowOnError>): RequestResult<ChildMetricsResponses, ChildMetricsErrors, ThrowOnError> => (options.client ?? client).get<ChildMetricsResponses, ChildMetricsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{childId}/metrics',
    ...options
});

/**
 * A child's own streak and badges
 *
 * Derived on read from the sessions, so it can never contradict the history a parent sees. It rewards showing up and getting there yourself — never speed, and never how much was done in one sitting.
 */
export const childProgress = <ThrowOnError extends boolean = false>(options: Options<ChildProgressData, ThrowOnError>): RequestResult<ChildProgressResponses, ChildProgressErrors, ThrowOnError> => (options.client ?? client).get<ChildProgressResponses, ChildProgressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{childId}/progress',
    ...options
});

/**
 * Is there a puzzle for this child?
 *
 * Each of today's sessions the eval sweep judged as solved by the child themselves earns one puzzle, up to two a day. `judging` counts sessions finished but not judged yet: ask again shortly. `open` is the newest puzzle while it is unsolved.
 */
export const puzzleShelf = <ThrowOnError extends boolean = false>(options: Options<PuzzleShelfData, ThrowOnError>): RequestResult<PuzzleShelfResponses, PuzzleShelfErrors, ThrowOnError> => (options.client ?? client).get<PuzzleShelfResponses, PuzzleShelfErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{childId}/puzzles',
    ...options
});

/**
 * Start an earned puzzle
 *
 * Spends one of today's puzzles. The child's own; a parent's tap is refused. The solution stays on the server.
 */
export const startPuzzle = <ThrowOnError extends boolean = false>(options: Options<StartPuzzleData, ThrowOnError>): RequestResult<StartPuzzleResponses, StartPuzzleErrors, ThrowOnError> => (options.client ?? client).post<StartPuzzleResponses, StartPuzzleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{childId}/puzzles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The parent's Lernbericht
 *
 * Written from the judged sessions and reused until new ones land. A parent only: it is written about the child, for somebody else. `basedOnSessions` of zero means nothing has been judged yet.
 */
export const childReport = <ThrowOnError extends boolean = false>(options: Options<ChildReportData, ThrowOnError>): RequestResult<ChildReportResponses, ChildReportErrors, ThrowOnError> => (options.client ?? client).get<ChildReportResponses, ChildReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{childId}/report',
    ...options
});

/**
 * A child's sessions, newest first
 *
 * The parent's Lernverlauf. A child sees only their own.
 */
export const listChildSessions = <ThrowOnError extends boolean = false>(options: Options<ListChildSessionsData, ThrowOnError>): RequestResult<ListChildSessionsResponses, ListChildSessionsErrors, ThrowOnError> => (options.client ?? client).get<ListChildSessionsResponses, ListChildSessionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{childId}/sessions',
    ...options
});

/**
 * A child's live share links
 *
 * A parent only. The links not yet revoked or expired, newest first, and the moments the child has reached that a new card could show.
 */
export const listShareCards = <ThrowOnError extends boolean = false>(options: Options<ListShareCardsData, ThrowOnError>): RequestResult<ListShareCardsResponses, ListShareCardsErrors, ThrowOnError> => (options.client ?? client).get<ListShareCardsResponses, ListShareCardsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{childId}/share-cards',
    ...options
});

/**
 * Make a share card
 *
 * A parent only. The card is a snapshot of the moment now, behind a link that expires in thirty days. It names the child only as `name` says, and never carries a worksheet, a task, an answer, a hint count or a time.
 */
export const createShareCard = <ThrowOnError extends boolean = false>(options: Options<CreateShareCardData, ThrowOnError>): RequestResult<CreateShareCardResponses, CreateShareCardErrors, ThrowOnError> => (options.client ?? client).post<CreateShareCardResponses, CreateShareCardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{childId}/share-cards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a child and everything under them
 *
 * Cascades to their PIN, their sessions and every transcript. A parent only.
 */
export const deleteChild = <ThrowOnError extends boolean = false>(options: Options<DeleteChildData, ThrowOnError>): RequestResult<DeleteChildResponses, DeleteChildErrors, ThrowOnError> => (options.client ?? client).delete<DeleteChildResponses, DeleteChildErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{id}',
    ...options
});

/**
 * One child
 *
 * A child may read themselves and nobody else, including a sibling on the same device.
 */
export const getChild = <ThrowOnError extends boolean = false>(options: Options<GetChildData, ThrowOnError>): RequestResult<GetChildResponses, GetChildErrors, ThrowOnError> => (options.client ?? client).get<GetChildResponses, GetChildErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{id}',
    ...options
});

/**
 * Rename a child or change their age mode
 */
export const updateChild = <ThrowOnError extends boolean = false>(options: Options<UpdateChildData, ThrowOnError>): RequestResult<UpdateChildResponses, UpdateChildErrors, ThrowOnError> => (options.client ?? client).patch<UpdateChildResponses, UpdateChildErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set a child's PIN
 *
 * A parent only. Signs out every session opened with the old PIN.
 */
export const setChildPin = <ThrowOnError extends boolean = false>(options: Options<SetChildPinData, ThrowOnError>): RequestResult<SetChildPinResponses, SetChildPinErrors, ThrowOnError> => (options.client ?? client).put<SetChildPinResponses, SetChildPinErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{id}/pin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * End a child's sign-in
 */
export const childSignOut = <ThrowOnError extends boolean = false>(options: Options<ChildSignOutData, ThrowOnError>): RequestResult<ChildSignOutResponses, ChildSignOutErrors, ThrowOnError> => (options.client ?? client).post<ChildSignOutResponses, ChildSignOutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/children/{id}/sign-out',
    ...options
});

/**
 * The curriculum a sheet is written to
 *
 * One school type's plan: subjects, grades, Lernbereiche and topics, paraphrased from LehrplanPLUS Bayern. A subject with `worksheets: false` has no paper sheets. A school type with no plan yet answers 404.
 */
export const getCurriculum = <ThrowOnError extends boolean = false>(options: Options<GetCurriculumData, ThrowOnError>): RequestResult<GetCurriculumResponses, GetCurriculumErrors, ThrowOnError> => (options.client ?? client).get<GetCurriculumResponses, GetCurriculumErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/curriculum',
    ...options
});

/**
 * Set the parent-mode PIN
 */
export const setParentPin = <ThrowOnError extends boolean = false>(options: Options<SetParentPinData, ThrowOnError>): RequestResult<SetParentPinResponses, SetParentPinErrors, ThrowOnError> => (options.client ?? client).put<SetParentPinResponses, SetParentPinErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/family/parent-pin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enter parent mode
 *
 * Re-authenticates a parent who is already signed in, on a shared device. It cannot create a session: a PIN that could would be a four-digit password on a device children use.
 */
export const checkParentPin = <ThrowOnError extends boolean = false>(options: Options<CheckParentPinData, ThrowOnError>): RequestResult<CheckParentPinResponses, CheckParentPinErrors, ThrowOnError> => (options.client ?? client).post<CheckParentPinResponses, CheckParentPinErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/family/parent-pin/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * A round
 *
 * The exercises and what was answered. Never the answers.
 */
export const getCardRound = <ThrowOnError extends boolean = false>(options: Options<GetCardRoundData, ThrowOnError>): RequestResult<GetCardRoundResponses, GetCardRoundErrors, ThrowOnError> => (options.client ?? client).get<GetCardRoundResponses, GetCardRoundErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/lernfach/rounds/{id}',
    ...options
});

/**
 * Answer an exercise
 *
 * One try. A wrong first try gets `tip`, where to look; a wrong second one sets `askSokrates`. Answering the last exercise finishes the round, and `round` then says what it earned.
 */
export const answerCardExercise = <ThrowOnError extends boolean = false>(options: Options<AnswerCardExerciseData, ThrowOnError>): RequestResult<AnswerCardExerciseResponses, AnswerCardExerciseErrors, ThrowOnError> => (options.client ?? client).post<AnswerCardExerciseResponses, AnswerCardExerciseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/lernfach/rounds/{id}/exercises/{exerciseId}/answer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The library's printable sets
 *
 * Hand-written sets: every set for a parent, and for a child the sets of their school type up to their grade, their own grade first (every set while the profile names no school type). Download a sheet, the set's bundle or its answers from `GET /library/{set}/{file}`, where file is a sheet's `file`, `bundle` or `answers`. The answers are a parent's.
 */
export const listLibrary = <ThrowOnError extends boolean = false>(options: Options<ListLibraryData, ThrowOnError>): RequestResult<ListLibraryResponses, ListLibraryErrors, ThrowOnError> => (options.client ?? client).get<ListLibraryResponses, ListLibraryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/library',
    ...options
});

/**
 * The caller and their organisations
 */
export const me = <ThrowOnError extends boolean = false>(options?: Options<MeData, ThrowOnError>): RequestResult<MeResponses, MeErrors, ThrowOnError> => (options?.client ?? client).get<MeResponses, MeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/me',
    ...options
});

/**
 * List members
 *
 * Filter properties: role, displayName, createdAt. Sort keys: displayName, role, createdAt.
 */
export const listMembers = <ThrowOnError extends boolean = false>(options: Options<ListMembersData, ThrowOnError>): RequestResult<ListMembersResponses, ListMembersErrors, ThrowOnError> => (options.client ?? client).get<ListMembersResponses, ListMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/members',
    ...options
});

/**
 * Seat a subject in the organisation
 */
export const createMember = <ThrowOnError extends boolean = false>(options: Options<CreateMemberData, ThrowOnError>): RequestResult<CreateMemberResponses, CreateMemberErrors, ThrowOnError> => (options.client ?? client).post<CreateMemberResponses, CreateMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a member
 */
export const deleteMember = <ThrowOnError extends boolean = false>(options: Options<DeleteMemberData, ThrowOnError>): RequestResult<DeleteMemberResponses, DeleteMemberErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMemberResponses, DeleteMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/members/{id}',
    ...options
});

/**
 * Get a member
 */
export const getMember = <ThrowOnError extends boolean = false>(options: Options<GetMemberData, ThrowOnError>): RequestResult<GetMemberResponses, GetMemberErrors, ThrowOnError> => (options.client ?? client).get<GetMemberResponses, GetMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/members/{id}',
    ...options
});

/**
 * Rename a member or change their role
 */
export const updateMember = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberData, ThrowOnError>): RequestResult<UpdateMemberResponses, UpdateMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMemberResponses, UpdateMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/members/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The current organisation
 */
export const getOrganization = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationData, ThrowOnError>): RequestResult<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organization',
    ...options
});

/**
 * Rename the organisation
 */
export const updateOrganization = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationData, ThrowOnError>): RequestResult<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organization',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Found an organisation
 *
 * The caller becomes its first owner.
 */
export const createOrganization = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationData, ThrowOnError>): RequestResult<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * A puzzle
 *
 * The board as it was last saved. Never the solution.
 */
export const getPuzzle = <ThrowOnError extends boolean = false>(options: Options<GetPuzzleData, ThrowOnError>): RequestResult<GetPuzzleResponses, GetPuzzleErrors, ThrowOnError> => (options.client ?? client).get<GetPuzzleResponses, GetPuzzleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/puzzles/{id}',
    ...options
});

/**
 * Save the board
 *
 * The board as the child has it, given digits unchanged. `solved` turns true when it is the solution, and stays true.
 */
export const savePuzzle = <ThrowOnError extends boolean = false>(options: Options<SavePuzzleData, ThrowOnError>): RequestResult<SavePuzzleResponses, SavePuzzleErrors, ThrowOnError> => (options.client ?? client).put<SavePuzzleResponses, SavePuzzleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/puzzles/{id}/cells',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Where to look next
 *
 * Saves the board and answers with a question and the cells it is about. Never a digit to write.
 */
export const puzzleHint = <ThrowOnError extends boolean = false>(options: Options<PuzzleHintData, ThrowOnError>): RequestResult<PuzzleHintResponses, PuzzleHintErrors, ThrowOnError> => (options.client ?? client).post<PuzzleHintResponses, PuzzleHintErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/puzzles/{id}/hint',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The family's invitation code
 *
 * A parent only. Made on first use. A family that signs up through the code tests for a month; when it first pays, this family gets a month free.
 */
export const getReferral = <ThrowOnError extends boolean = false>(options: Options<GetReferralData, ThrowOnError>): RequestResult<GetReferralResponses, GetReferralErrors, ThrowOnError> => (options.client ?? client).get<GetReferralResponses, GetReferralErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/referral',
    ...options
});

/**
 * Record that this family came through an invitation
 *
 * A parent of a family still in its first trial. The trial runs a month from the family's start instead of fourteen days.
 */
export const claimReferral = <ThrowOnError extends boolean = false>(options: Options<ClaimReferralData, ThrowOnError>): RequestResult<ClaimReferralResponses, ClaimReferralErrors, ThrowOnError> => (options.client ?? client).post<ClaimReferralResponses, ClaimReferralErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/referral/claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start a dialogue over a worksheet
 *
 * The photograph is read once, here, and everything the dialogue will ever know about the sheet comes out of that call. It is then kept only while the session is active, so the child can see it beside the conversation.
 */
export const startSession = <ThrowOnError extends boolean = false>(options: Options<StartSessionData, ThrowOnError>): RequestResult<StartSessionResponses, StartSessionErrors, ThrowOnError> => (options.client ?? client).post<StartSessionResponses, StartSessionErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sessions',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Start a dialogue from a typed question
 *
 * For a child with no photograph — the same rules, one fewer input.
 */
export const startTextSession = <ThrowOnError extends boolean = false>(options: Options<StartTextSessionData, ThrowOnError>): RequestResult<StartTextSessionResponses, StartTextSessionErrors, ThrowOnError> => (options.client ?? client).post<StartTextSessionResponses, StartTextSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sessions/ask',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start a dialogue over a printed sheet
 *
 * The child has an Arbeitsblatt from the library or one written for the family in front of them, on paper. No photograph: the server already has the sheet's tasks, and the tutor keeps them in view for the whole dialogue.
 */
export const startSheetSession = <ThrowOnError extends boolean = false>(options: Options<StartSheetSessionData, ThrowOnError>): RequestResult<StartSheetSessionResponses, StartSheetSessionErrors, ThrowOnError> => (options.client ?? client).post<StartSheetSessionResponses, StartSheetSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sessions/sheet',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a session and its transcript
 */
export const deleteSession = <ThrowOnError extends boolean = false>(options: Options<DeleteSessionData, ThrowOnError>): RequestResult<DeleteSessionResponses, DeleteSessionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSessionResponses, DeleteSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sessions/{id}',
    ...options
});

/**
 * A session and its transcript
 */
export const getSession = <ThrowOnError extends boolean = false>(options: Options<GetSessionData, ThrowOnError>): RequestResult<GetSessionResponses, GetSessionErrors, ThrowOnError> => (options.client ?? client).get<GetSessionResponses, GetSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sessions/{id}',
    ...options
});

/**
 * What this sheet is about, explained
 *
 * The side door for a curious child: the topic and the idea behind the exercises, from the deliberate inverse of Sokrates. It still does not solve anything, and it is not written to the transcript.
 */
export const background = <ThrowOnError extends boolean = false>(options: Options<BackgroundData, ThrowOnError>): RequestResult<BackgroundResponses, BackgroundErrors, ThrowOnError> => (options.client ?? client).post<BackgroundResponses, BackgroundErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sessions/{id}/background',
    ...options
});

/**
 * End a session
 *
 * The transcript stays for the parent's history; the photograph is destroyed.
 */
export const finishSession = <ThrowOnError extends boolean = false>(options: Options<FinishSessionData, ThrowOnError>): RequestResult<FinishSessionResponses, FinishSessionErrors, ThrowOnError> => (options.client ?? client).post<FinishSessionResponses, FinishSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sessions/{id}/finish',
    ...options
});

/**
 * A ticket for a real-time voice session
 *
 * Single-use, expiring within two minutes, and good for this session only. Open `GET /sessions/{id}/live?ticket=…&rate=…` as a WebSocket with it: binary frames up are the microphone as 16-bit mono PCM at `rate` Hz, binary frames down are the tutor at `outputRate` Hz, and text frames down are events (`ready`, `interrupted`, `turn`, `error`). The model, the voice and the rules are set by this app; completed turns are written to the transcript here.
 */
export const liveToken = <ThrowOnError extends boolean = false>(options: Options<LiveTokenData, ThrowOnError>): RequestResult<LiveTokenResponses, LiveTokenErrors, ThrowOnError> => (options.client ?? client).post<LiveTokenResponses, LiveTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sessions/{id}/live-token',
    ...options
});

/**
 * Answer the tutor, and get the next question
 */
export const reply = <ThrowOnError extends boolean = false>(options: Options<ReplyData, ThrowOnError>): RequestResult<ReplyResponses, ReplyErrors, ThrowOnError> => (options.client ?? client).post<ReplyResponses, ReplyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sessions/{id}/reply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Turn a recorded answer into text
 *
 * The words come back; they are not sent. The child sees what was heard and can fix it before the tutor reads it.
 */
export const transcribe = <ThrowOnError extends boolean = false>(options: Options<TranscribeData, ThrowOnError>): RequestResult<TranscribeResponses, TranscribeErrors, ThrowOnError> => (options.client ?? client).post<TranscribeResponses, TranscribeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sessions/{id}/transcribe',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record a spoken turn
 *
 * A real-time voice session happens between the browser and the provider, so its turns are posted back here. Parent history and the eval sweep see a spoken turn exactly as a typed one.
 */
export const appendTurn = <ThrowOnError extends boolean = false>(options: Options<AppendTurnData, ThrowOnError>): RequestResult<AppendTurnResponses, AppendTurnErrors, ThrowOnError> => (options.client ?? client).post<AppendTurnResponses, AppendTurnErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sessions/{id}/turns',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Take a share link back
 *
 * A parent only. The link stops answering at once.
 */
export const revokeShareCard = <ThrowOnError extends boolean = false>(options: Options<RevokeShareCardData, ThrowOnError>): RequestResult<RevokeShareCardResponses, RevokeShareCardErrors, ThrowOnError> => (options.client ?? client).delete<RevokeShareCardResponses, RevokeShareCardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/share-cards/{id}',
    ...options
});

/**
 * The family's written sheets
 *
 * Filter properties: school, subject, grade, level, childId, createdAt. Sort keys: createdAt, title, grade, subject. A child sees the family's sheets and their own. Download one from `GET /sheets/{id}/pdf`; a parent adds `?answers=true` for the answer page.
 */
export const listSheets = <ThrowOnError extends boolean = false>(options: Options<ListSheetsData, ThrowOnError>): RequestResult<ListSheetsResponses, ListSheetsErrors, ThrowOnError> => (options.client ?? client).get<ListSheetsResponses, ListSheetsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sheets',
    ...options
});

/**
 * Write a new sheet to a curriculum topic
 *
 * The model writes it; this takes a few seconds. A parent only, and gated by the plan like a new session.
 */
export const createSheet = <ThrowOnError extends boolean = false>(options: Options<CreateSheetData, ThrowOnError>): RequestResult<CreateSheetResponses, CreateSheetErrors, ThrowOnError> => (options.client ?? client).post<CreateSheetResponses, CreateSheetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sheets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a written sheet
 *
 * Sessions started from it keep their transcript.
 */
export const deleteSheet = <ThrowOnError extends boolean = false>(options: Options<DeleteSheetData, ThrowOnError>): RequestResult<DeleteSheetResponses, DeleteSheetErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSheetResponses, DeleteSheetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sheets/{id}',
    ...options
});

/**
 * A written sheet
 */
export const getSheet = <ThrowOnError extends boolean = false>(options: Options<GetSheetData, ThrowOnError>): RequestResult<GetSheetResponses, GetSheetErrors, ThrowOnError> => (options.client ?? client).get<GetSheetResponses, GetSheetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sheets/{id}',
    ...options
});

/**
 * Write the next sheet on the same topic
 *
 * Same topic, same child, and the level moved by how the child got on with this sheet in their sessions with Sokrates: up a step when they solved it alone with at most one hint, down a step when they did not get there or needed three or more, the same in between. `reason` says which, for the parent. Like writing a sheet: a parent only, gated by the plan.
 */
export const nextSheet = <ThrowOnError extends boolean = false>(options: Options<NextSheetData, ThrowOnError>): RequestResult<NextSheetResponses, NextSheetErrors, ThrowOnError> => (options.client ?? client).post<NextSheetResponses, NextSheetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sheets/{id}/next',
    ...options
});
